import { SortCriteriaOption } from '@steelbuy/ui-domain';

export const SORT_OPTIONS = [
    SortCriteriaOption.PRICE_DESCENDING,
    SortCriteriaOption.PRICE_ASCENDING,
    SortCriteriaOption.WEIGHT_DESCENDING,
    SortCriteriaOption.WEIGHT_ASCENDING,
    SortCriteriaOption.EXPIRES_AT_DESCENDING,
    SortCriteriaOption.EXPIRES_AT_ASCENDING,
];
